// extracted by mini-css-extract-plugin
module.exports = {"pagesSidebar":"Oprzn","collapsedPagesSidebar":"ccbsx","sidebarHeader":"OF8li","sidebarList":"vc4Cv","hiddenPagesSidebar":"UJ-6v"};